import { Form, Input, Row, Col, Card } from "antd";
import { IEnderecoPessoaFisica } from "./InterfacePessoaFisica";
import { maskCep } from "../../../utils/maskFunctions";

interface IProps {
  endereco: IEnderecoPessoaFisica;
}

const PessoaFisicaEndereco = ({ endereco }: IProps) => {

  return (
    <Card variant="borderless" style={{ width: "100%" }}>
      <>
        <Row>
          <Col xs={24} sm={8}>
            <Form.Item label='Tipo Endereço'
              labelCol={{ span: 12 }}
              wrapperCol={{ span: 24 }}
              name="tipoEndereco"
            >
              <Input disabled={true} placeholder={endereco.tipoEndereco} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item label='CEP'
              name="nuCep"
            >
              <Input disabled={true} placeholder={maskCep(endereco.nuCep)} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={18}>
            <Form.Item label='Endereço'
              labelCol={{ span: 16 }}
              labelAlign="left"
              name="teEndereco"
            >
              <Input disabled={true} placeholder={endereco.teEndereco?.toUpperCase()} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={6}>
            <Form.Item label='Número'
              name="nuEndereco"
            >
              <Input disabled={true} placeholder={endereco.nuEndereco?.toUpperCase()} />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} sm={16}>
            <Form.Item label='Complemento'
              labelCol={{ span: 16 }}
              labelAlign="left"
              name={"teComplemento"}
            >
              <Input disabled={true} placeholder={endereco.teComplemento?.toUpperCase()} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item label='Bairro'
              name={"nmBairro"}
            >
              <Input disabled={true} placeholder={endereco.nmBairro?.toUpperCase()} />
            </Form.Item>
          </Col>
        </Row>

        <Row>

          <Col xs={24} sm={8}>
            <Form.Item label='País'
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 24 }}
              labelAlign="left"
              colon={false}
              name="nmPais"
            >
              <Input disabled={true} placeholder={endereco.nmPais?.toUpperCase()} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item label='UF'
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 24 }}
              labelAlign="left"
              colon={false}
              name="nmEstado"
            >
              <Input disabled={true} placeholder={endereco.nmEstado?.toUpperCase()} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item label='Município'
              name="nmCidade"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 24 }}
            >
              <Input disabled={true} placeholder={endereco.nmCidade?.toUpperCase()} />
            </Form.Item>
          </Col>
        </Row>
      </>
    </Card>

  );
};

export default PessoaFisicaEndereco;